import {useCustomQuery} from '@salesforce/commerce-sdk-react'

const upsAddressValidation = (address) => {
    return useCustomQuery(
        {
            options: {
                method: 'POST',
                customApiPathParameters: {
                    apiName: 'validate-address',
                    apiVersion: 'v1',
                    endpointPath: 'upsAddressValidation'
                },
                body: JSON.stringify(address)
            }
        },
        {
            enabled: address && Object.keys(address).length > 0
        }
    )
}

export default upsAddressValidation
